import { AnimatePresence, motion } from 'framer-motion';

import { Photo } from '../Photo/Photo';

import styles from './Message.module.css';

const Message = ({ currentMessage, message, duration, authorFontSize }) => {
  const durationSec = duration / 1000;

  const startDutation = 1.5; // анимация появления фото
  const exitDuration = 1;
  // общая длительность видимости фото
  const allDurationSlide = durationSec - exitDuration - startDutation;
  const delayStartBgVideo = allDurationSlide / 2 - 1 + startDutation;

  return (
    <div className={styles.wrapper}>
      <AnimatePresence mode="wait">
        <motion.div
          key={currentMessage.id}
          exit={{
            y: '-100vh',
            scale: 0.5,
            opacity: 0,
            transition: {
              duration: exitDuration,
            },
          }}
          className={styles.photoBlock}
        >
          <Photo
            message={message}
            authorFontSize={authorFontSize}
            delayStartBgVideo={delayStartBgVideo}
          />
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default Message;
